/* F24 - Atribucion de fuente INVISIBLE en links de WhatsApp (Google vs Facebook vs organico/directo).
 * Captura gclid/fbclid/utm en el aterrizaje, lo persiste (first-party, 90d), y agrega al `text`
 * de TODOS los links wa.me / api.whatsapp.com un marcador INVISIBLE (caracteres de ancho cero).
 * El cliente NO lo ve; viaja en su primer mensaje -> queda en GHL -> se clasifica la fuente.
 * Marcador: U+2063 (centinela) + 1 char invisible por fuente:
 *   g=U+200B (google) - f=U+200C (meta/facebook) - o=U+200D (otro/organico) - d=U+2060 (directo)
 * Codigos construidos con String.fromCharCode (fuente 100% ASCII, sin chars invisibles literales).
 * Fail-safe: cualquier error deja los links intactos (no rompe el boton de WhatsApp).
 * Nota: el detalle de campana vive en cada ad platform (gclid/fbclid); aqui solo marcamos plataforma.
 */
(function () {
  try {
    var SEARCH = /(google|bing|yahoo|duckduckgo|ecosia|yandex)\./i;
    var KEY = "f24_src";
    var SENT = String.fromCharCode(0x2063);                       // centinela invisible
    var MARK = {
      g: String.fromCharCode(0x200B),
      f: String.fromCharCode(0x200C),
      o: String.fromCharCode(0x200D),
      d: String.fromCharCode(0x2060)
    };

    function qp(n) { try { return new URLSearchParams(location.search).get(n); } catch (e) { return null; } }
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch (e) { return {}; } }
    function write(o) {
      try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {}
      try { document.cookie = KEY + "=" + encodeURIComponent(JSON.stringify(o)) + ";path=/;max-age=7776000;samesite=lax"; } catch (e) {}
    }
    function slug(x) { return (x || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 24); }

    var stored = read();
    var gclid = qp("gclid") || qp("gbraid") || qp("wbraid");
    var fbclid = qp("fbclid");
    var utmS = (qp("utm_source") || "").toLowerCase();
    var utmC = qp("utm_campaign") || "";
    var utmContent = qp("utm_content") || "";                     // nombre del ad (Meta lo setea via utm_content={{ad.name}})
    function san(x) { return (x || "").replace(/[^A-Za-z0-9_.\-]+/g, "-").replace(/^-|-$/g, "").slice(0, 60); }

    var src = null;
    if (gclid) src = "g";
    else if (fbclid || /facebook|fb|instagram|ig|meta/.test(utmS)) src = "f";
    else if (utmS) src = "o";
    if (src) { stored = { src: src, camp: slug(utmC), adname: san(utmContent), gclid: gclid || "", fbclid: fbclid || "", ts: Date.now() }; write(stored); }
    else if (utmContent) { stored.adname = san(utmContent); stored.ts = Date.now(); write(stored); }

    var eff = stored.src;
    if (!eff) eff = (document.referrer && SEARCH.test(document.referrer)) ? "o" : "d";
    var CODE = SENT + (MARK[eff] || MARK.d);                       // invisible: centinela + fuente

    // Solo Google necesita el gclid literal (Meta casa por telefono; Google obliga gclid).
    // Se agrega VISIBLE y delimitado al final ("ref:<gclid>") para que Make lo extraiga.
    // Solo cuando la fuente efectiva es google Y hay gclid capturado. gclid = [A-Za-z0-9_-], sin espacios.
    var REF = (eff === "g" && stored.gclid) ? (" ref:" + stored.gclid) : "";
    // Nombre del ad (utm_content) para atribucion POR-ANUNCIO en WhatsApp -> Make lo extrae con "ad:".
    // ad = [A-Za-z0-9_.-] sanitizado, sin espacios. Aplica a cualquier fuente que traiga utm_content.
    var AD = stored.adname ? (" ad:" + stored.adname) : "";

    // Helper global para CTAs que abren WhatsApp via window.open (formularios) en vez de
    // un <a href>. Recibe una URL wa.me y devuelve la misma con el marcador invisible
    // (+ ref:<gclid> si la fuente es google) agregado al parametro text.
    // Fail-safe: ante cualquier error devuelve la URL intacta.
    try {
      window.F24_STAMP = function (waUrl) {
        try {
          var u2 = new URL(waUrl, location.origin);
          var t2 = u2.searchParams.get("text") || "";
          if (t2.indexOf(SENT) === -1) u2.searchParams.set("text", t2 + CODE + REF + AD);
          return u2.toString();
        } catch (e) { return waUrl; }
      };
    } catch (e) {}

    function stamp(a) {
      try {
        var href = a.getAttribute("href") || "";
        if (!/wa\.me|api\.whatsapp\.com/i.test(href)) return;
        var u = new URL(href, location.origin);
        var t = u.searchParams.get("text") || "";
        if (t.indexOf(SENT) > -1) return;                         // ya estampado
        u.searchParams.set("text", t + CODE + REF + AD);          // invisible (fuente) + gclid(google) + ad(utm_content)
        a.setAttribute("href", u.toString());
      } catch (e) {}
    }
    function stampAll() {
      try {
        var L = document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]');
        for (var i = 0; i < L.length; i++) stamp(L[i]);
      } catch (e) {}
    }

    if (document.readyState !== "loading") stampAll();
    else document.addEventListener("DOMContentLoaded", stampAll);
    document.addEventListener("click", function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href*="wa.me"], a[href*="whatsapp.com"]');
      if (a) stamp(a);
    }, true);

    // --- ROBUSTEZ (aditivo, no toca stamp() ni el path de los <a> que ya funciona) ---
    var WA = /wa\.me|api\.whatsapp\.com|whatsapp\.com\/send/i;

    // 1) Re-estampar cualquier <a> wa.me cuyo href cambie por JS (ej. f24-promo MSI selector
    //    linea 'wa.setAttribute(href,...)'), que ANTES borraba el marcador ya puesto.
    //    Cuando stamp() re-escribe el href, el guard de SENT evita bucle (queda no-op).
    try {
      if (window.MutationObserver) {
        var mo = new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            var t = muts[i].target;
            if (t && t.tagName === "A" && WA.test(t.getAttribute("href") || "")) stamp(t);
          }
        });
        mo.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ["href"] });
      }
    } catch (e) {}

    // 2) Red de seguridad para CTAs que abren WhatsApp via window.open (aunque no llamen F24_STAMP).
    try {
      var _open = window.open;
      window.open = function (u) {
        try { if (u && typeof u === "string" && WA.test(u)) u = window.F24_STAMP ? window.F24_STAMP(u) : u; } catch (e) {}
        return _open.apply(window, [u].concat([].slice.call(arguments, 1)));
      };
    } catch (e) {}

    // 3) Re-stamp tardio (secciones que renderizan/montan despues del load) + en primera interaccion.
    try {
      setTimeout(stampAll, 1500);
      var once = function () { stampAll(); document.removeEventListener("pointerdown", once, true); };
      document.addEventListener("pointerdown", once, true);
    } catch (e) {}
  } catch (e) {}
})();
